// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CallController from "./call_controller"
application.register("call", CallController)
import AiPollController from "./ai_poll_controller"
application.register("ai-poll", AiPollController)

import ChartLinksController from "./chart_links_controller"
application.register("chart-links", ChartLinksController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)
import DealsBoardController from "./deals_board_controller"
application.register("deals-board", DealsBoardController)
import GlobalSearchController from "./global_search_controller"
application.register("global-search", GlobalSearchController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LostReasonController from "./lost_reason_controller"
application.register("lost-reason", LostReasonController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TodayController from "./today_controller"
application.register("today", TodayController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)
